import AlertModal from "@/components/common/modals/alert-modal";
import ToolbarButton from "./toolbar-button";
import { useState } from "react";

const HtmlReset = ({ onReset }: { onReset: () => void }) => {
  const [resetConfirmOpen, setResetConfirmOpen] = useState(false);

  const openReset = () => setResetConfirmOpen(true);
  const closeReset = () => setResetConfirmOpen(false);

  const handleConfirmReset = () => {
    onReset();
    closeReset();
  };

  return (
    <>
      <ToolbarButton
        className="flex w-fit items-center gap-x-1"
        onClick={openReset}
      >
        {/* آیکون شبیه Orientation */}
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 3.333A6.667 6.667 0 1016.667 10H15A5 5 0 1110 5V3.333Z"
            stroke="#273646"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Reset
      </ToolbarButton>

      <AlertModal
        isOpen={resetConfirmOpen}
        isLoading={false}
        onClose={closeReset}
        onConfirm={handleConfirmReset}
      />
    </>
  );
};

export default HtmlReset;
